export default __webpack_public_path__ + "static/media/270.690f44a0.png";